import React, { useEffect, useRef, useState } from 'react';
import { Input } from '../TextInput/Input';
import classNames from 'classnames';
import cls from './Editable.module.css';
import { useStore } from 'react-redux';

export const Editable = ({
    isDisabled = false,
    valueMain,
    valueSecond,
    handler,
    mainName,
    secondName,
    title,
    icon,
    error,
    isRequired = false,
    active = false,
}) => {
    const [initRender, setInitRender] = useState(true);
    const [isActiveInput, setIsActiveInput] = useState(active);

    const [autofocus, setAutofocus] = useState(false);
    useEffect(() => {
        if (initRender) {
            setInitRender(false);
        } else {
            setIsActiveInput(false);
            const fakeEvent = {
                target: { name: secondName, value: valueMain },
            };
            handler(fakeEvent);
        }
    }, [valueMain, isDisabled]);

    const fakeInputHandler = () => {
        if (isDisabled) return;

        setIsActiveInput(true);
        setAutofocus(true);
    };

    return (
        <>
            {isActiveInput ? (
                <Input
                    isRequired={isRequired}
                    onChange={handler}
                    title={title}
                    value={valueSecond}
                    isDisabled={isDisabled}
                    icon={icon}
                    error={error}
                    name={secondName}
                    autofocus={autofocus}
                    setIsFocused={setAutofocus}
                />
            ) : (
                <div className={classNames(cls.formBlockContent, { [cls.disabled]: isDisabled })}>
                    {title && (
                        <label className={classNames(cls.modalLabelSelect)}>
                            {title}
                            {isRequired && <span>*</span>}
                        </label>
                    )}
                    <div onClick={fakeInputHandler} className={classNames(cls.inputWrapper)}>
                        <div className={classNames(cls.input)}>{valueMain}</div>
                        {icon && <div className={classNames(cls.inputIcon)}>{icon}</div>}
                    </div>
                    {error && <span className={classNames(cls.errorMessage)}>{error}</span>}
                </div>
            )}
        </>
    );
};
